module.exports = __webpack_public_path__ + "static/transportation-for-seniors-3be9d8c58daf220fba81889eed8e1439.jpg";